import React from 'react'
import get from 'lodash/get'
import styled from 'styled-components'
import dayjs from 'dayjs'

const RoundIcon = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    color: ${p=>p.theme.colors.text[p.color]};
    font-size:1.3rem;
    opacity: ${p=>p.opacity ? p.opacity : 1 };
`

const MINS = 60


const string = ({row,name,keyValue = null}) => {
    const newChat = get(row,'notifications.newChat', false)


    if( newChat) {
        return <RoundIcon color='info' className='fad fa-comment'/> 
    }

    let mins = dayjs().diff(dayjs(row.updated), 'm');

    if( mins <= MINS ) {
        return <RoundIcon opacity={(MINS-mins)/MINS} color='danger' className='fad fa-heart-rate'/> 
    }

    return null
}

export default string

